<div class="aboutUsImage">
  <div class="card mb-4 box-shadow">
    <img class="card-img card-img-top flex-auto d-md-block" src="{{data.imageUrl}}" alt="{{data.fullName}}" />
    <div class="card-body d-flex flex-column">
      <h4 class="mb-0">
        <!-- <a class="text-dark" routerLink="/about/{{data.url}}"></a>--> {{data.fullName}}
      </h4>
      @for (t of data.titles; track t) {
        <p class="card-role mb-0">{{t}}</p>
      }
      <!-- <h5 class="card-text mb-3 mt-3 twentyfour">{{data.credentials}}</h5> -->
      <!-- <a routerLink="/about/{{data.url}}" class="btn btn-primary advisorButtons">View Profile</a> -->
    </div>
  </div>
</div>